import { TransferOrderKind as TransferOrderKindEnum } from "@redotech/crdb-enums/inventory/transfer-order-kind";
import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import {
  PackingMode,
  PackingModeSchema,
} from "@redotech/redo-inventory-common/packing-mode";
import {
  locationIdFormat,
  transferOrderIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { TransferOrderKind } from "./transfer-types";

export const createTransfer = {
  name: "createTransfer" as const,
  input: z.object({
    originLocationId: locationIdFormat.schema,
    destinationLocationId: locationIdFormat.schema,
    kind: TransferOrderKind.default(TransferOrderKindEnum.Simple),
    notes: z.string().nullish(),
    tags: z.array(z.string()).default([]),
    products: z
      .array(
        z.object({
          productId: productIdFormat.schema,
          expectedQuantity: z.number().int().min(1),
          packingMode: PackingModeSchema.default(PackingMode.INDIVIDUAL),
          packingTemplateId: packingTemplateIdFormat.schema
            .nullable()
            .optional(),
          enteredQuantity: z.number().int().default(0),
        }),
      )
      .optional(),
  }),
  output: z.object({ transferId: transferOrderIdFormat.schema }),
};
